import { render } from "./WpeSelect.vue?vue&type=template&id=0ffdf31f"
import script from "./WpeSelect.vue?vue&type=script&lang=js"
export * from "./WpeSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ffdf31f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ffdf31f', __exports__)) {
    api.reload('0ffdf31f', __exports__)
  }
  
  module.hot.accept("./WpeSelect.vue?vue&type=template&id=0ffdf31f", () => {
    api.rerender('0ffdf31f', render)
  })

}


export default __exports__